import getCookie from '@updater-core/interactors/shell/tracker/utils/getCookie';

export default function getItemFromStorage (name) {
  if (typeof localStorage === 'undefined') return undefined;
  const item = localStorage.getItem(name) || getCookie(name);
  return item;
}
